import { validateDependentList } from './dependentListValidator'
import { validateDrilldownList } from './drilldownListValidator'
import { validateDropdownList } from './dropdownListValidator'
import {
  FieldId,
  ValidationGovernanceOwner,
  ValidationTemplateField,
  ValidationValue,
} from '../validationTypes'
import { t } from '@lingui/core/macro'

export interface ValidationFeedback {
  errors: string[]
  warnings: string[]
}

/**
 * Determines which list type needs to be validated and passes the logic on
 * to the list validator of that type.
 * @param valueObj
 * @param governanceOwner
 * @param dependentFields
 * @param rowNum
 * @param data
 * @param feedback
 */
export function validateList(
  valueObj: ValidationValue,
  governanceOwner: ValidationGovernanceOwner,
  dependentFields: ValidationTemplateField[],
  rowNum: number,
  data: Record<FieldId, ValidationValue>[],
  feedback: ValidationFeedback,
) {
  if (!governanceOwner.list_governance) {
    feedback.errors.push(t`List governance is not defined.`)

    return
  }

  const listGovernance = governanceOwner.list_governance
  const list = listGovernance.lists
  const value = valueObj.cell_value

  if (Array.isArray(valueObj.metadata?.source) && list.type === 'drill-down') {
    validateDrilldownList(value, valueObj.metadata.validOptions ?? [], governanceOwner, feedback)

    return
  }

  if (list.type === 'dependent') {
    const rowData = data[rowNum] ?? {}

    validateDependentList(value, rowData, listGovernance, dependentFields, feedback)

    return
  }

  validateDropdownList(value, listGovernance, null, feedback)
}
